import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import {
  CfgUIElementState,
  ConfiguratorUIElementStates,
  ConfiguratorUIElementWithChildrenState,
} from './CfgUIElementState';
import { IUiCfgContainer, IUiCfgContainerItem } from '@canvas-logic/clp-api-types';
import { getContainerUIElement, getUIElement } from '@/stores/UIElementStorage';

export function createConfiguratorUIElementState(
  api: ICompositeProductApi,
  element: IUiCfgContainerItem,
  container: IUiCfgContainer,
): CfgUIElementState {
  const state = getUIElement(element.kind, element.type).init({
    api,
    viewElement: element,
    componentSettings: container.componentsSettings,
    productsSettings: container.productsSettings,
    attributeSettings: container.attributesSettings,
  });

  return state;
}

export function createConfiguratorContainerUIElementState(
  api: ICompositeProductApi,
  element: IUiCfgContainerItem,
  children: Array<ConfiguratorUIElementStates>,
): ConfiguratorUIElementWithChildrenState {
  const state = getContainerUIElement(element.kind, element.type).init({
    api,
    viewElement: element,
    children,
  });

  return state;
}

export function templateValue(template: string, object: Record<string, string>) {
  return template.replace(/\{(.*?)\}/g, (match, key) => {
    if (!(key in object)) {
      throw new Error(`Invalid key ${key} in template: "${template}"`);
    }
    return object[key].toString();
  });
}
